// eslint-disable-next-line no-shadow
enum Role {
    ADMIN = 'Admin',
    DEVELOPER = 'Developer',
    USER = 'User',
    NOROLE = '',
}

export default Role;
